export default __webpack_public_path__ + "static/graph-c1be992d6f4e8c65b4c806b7707c6793.webp";